<div class="layer_details__subtitle">Dimensions:</div>
<app-layer-details-dimension-row
  label="Width:"
  [value]="(layer | rectDimensions).width"
  [unitsSystem]="unitsSystem"
></app-layer-details-dimension-row>
<app-layer-details-dimension-row
  label="Height:"
  [value]="(layer | rectDimensions).height"
  [unitsSystem]="unitsSystem"
></app-layer-details-dimension-row>
<app-layer-details-dimension-row
  label="Depth:"
  [value]="(layer | rectDimensions).depth"
  [unitsSystem]="unitsSystem"
></app-layer-details-dimension-row>
<app-layer-details-rect-footer
  [layer]="layer"
  (copyClicked)="copyDimensions()"
></app-layer-details-rect-footer>
